import { postJSON } from "../utils/http.js"
export function wareSearch(params, config = { loading: true }) {
  return postJSON("/api/item/wareSearch", params, config)
}

// 包含过滤数据
export function searchTemplateData(params, config = {}) {
  return postJSON("/api/item/searchTemplateData", params, config)
}
export function getCategory(params, config = {}) {
  return postJSON("/api/category/getCategory", params, config)
}
